module.exports = __webpack_public_path__ + "static/media/book.179d7be0.svg";